import { Sparkles, X } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface SmartFillPromptProps {
	count: number;
	contractTypeDisplay: string;
	onApply: () => void;
	onDismiss: () => void;
}

const SmartFillPrompt = ({
	count,
	contractTypeDisplay,
	onApply,
	onDismiss
}: SmartFillPromptProps) => {
	const { t } = useTranslation();

	return (
		<div
			className="relative my-2 p-3 bg-background border border-border rounded-lg shadow-md animate-in fade-in slide-in-from-top-2 duration-200"
			data-testid="smart-fill-prompt"
		>
			<button
				type="button"
				onClick={onDismiss}
				className="absolute top-2 right-2 text-muted-foreground hover:text-foreground"
				data-testid="smart-fill-dismiss-x"
				aria-label="Close"
			>
				<X className="h-3.5 w-3.5" />
			</button>
			<div className="flex items-start gap-2 pr-4">
				<Sparkles className="h-4 w-4 text-destructive mt-0.5 shrink-0" />
				<div className="text-sm">
					<p className="mb-2">
						<Trans
							i18nKey="quotes.settings.employees.smartFill.prompt"
							values={{ count, contractType: contractTypeDisplay }}
							components={{ i: <em className="text-destructive font-medium not-italic" /> }}
						/>
					</p>
					<div className="flex gap-2">
						<Button
							size="sm"
							variant="destructive"
							onClick={onApply}
							data-testid="smart-fill-apply"
						>
							{t('quotes.settings.employees.smartFill.applyAll')}
						</Button>
						<Button
							size="sm"
							variant="outline"
							onClick={onDismiss}
							data-testid="smart-fill-dismiss"
						>
							{t('quotes.settings.employees.smartFill.dismiss')}
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SmartFillPrompt;
